export default __webpack_public_path__ + "static/media/avatarIcon.95208bf9.png";